import React from 'react';
import { Hero } from '../components/Hero';
import { Problem } from '../components/Problem';
import { Solution } from '../components/Solution';
import { Audience } from '../components/Audience';
import { ClosingSection } from '../components/ClosingSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-cream selection:bg-terra/20 selection:text-olive" data-id="element-204">
      <Hero data-id="element-205" />
      <Problem data-id="element-206" />
      <Solution data-id="element-207" />
      <Audience data-id="element-208" />
      <ClosingSection data-id="element-209" />
      <Footer data-id="element-210" />
    </main>;
}